import React, { Component } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Card,
  Input,
  message,
  Tabs,
  Select,
  Spin,
  Switch,
} from "antd";
import axios from "services/axios";
import RolePicker from "comp/RolePicker";
import Lightbox from "react-image-lightbox";

const FormItem = Form.Item;
const { TabPane } = Tabs;
const { Option } = Select;

class UserCreate extends Component {
  constructor(props) {
    super(props);
    this.fileInputKTP = React.createRef();
    this.fileInputNPWP = React.createRef();
    this.state = {
      supervisors: [],
      mobbiSupervisors: [],
      tntUsers: [],
      branches: [],
      areaBranches: [],
      areaBusinesses: [],
      loading: false,
      npwpImage: null,
      ktpImage: null,
      visibleModalKTP: false,
      visibleModalNPWP: false,
    };
  }

  triggerInputFile = (type) => {
    if (type == "ktp") {
      if (this.fileInputKTP.current && this.fileInputKTP.current.click) {
        this.fileInputKTP.current.click();
      }
    } else {
      if (this.fileInputNPWP.current && this.fileInputNPWP.current.click) {
        this.fileInputNPWP.current.click();
      }
    }
  };

  setSelectedImage(image, type) {
    if (type === "ktp") {
      this.setState({ ktpImage: image });
    } else {
      this.setState({ npwpImage: image });
    }
  }

  visibleModal(type, val) {
    switch (type) {
      case "ktp":
        this.setState({ visibleModalKTP: val });
        break;
      case "npwp":
        this.setState({ visibleModalNPWP: val });
        break;
    }
  }

  getQueryUser() {
    return (this.props.location.query && this.props.location.query.user) || "";
  }

  handleSubmit = (e, role) => {
    let self = this;
    e.preventDefault();
    this.setState({ loading: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (values.email) {
        let userData = {
          name: values.name,
          email: values.email,
          phone: values.phone,
          password: process.env.REACT_APP_DEFAULT_PASSWORD,
          role: values.role,
        };
        if (!err) {
          axios
            .post(`/admin-panel/user/create-other/${role}`, userData)
            .then((result) => {
              message.success(
                `Berhasil menambah user ${values.name} dengan role ${values.role}`
              );
              this.props.history.push(
                `/home/${this.props.location.query.role}-user`
              );
              self.setState({ loading: false });
            })
            .catch((err) => {
              this.errorMessage(err);
              self.setState({ loading: false });
            });
        } else {
          this.setState({ loading: false });
        }
      } else {
        message.error(`Email wajib diisi`);
        this.setState({ loading: false });
      }
    });
  };

  createAppraiser = (e, role) => {
    let self = this;
    e.preventDefault();
    this.setState({ loading: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (values.email) {
        let userData = {
          name: values.name,
          email: values.email,
          phone: values.phone,
          password: process.env.REACT_APP_DEFAULT_PASSWORD,
          role: values.role,
          isDisableAppraisal: !values.isDisableAppraisal,
        };
        if (!err) {
          axios
            .post(`/admin-panel/user/create-appraiser`, userData)
            .then((result) => {
              message.success(
                `Berhasil menambah user ${values.name} dengan role ${values.role}`
              );
              this.props.history.push(
                `/home/${this.props.location.query.role}-user`
              );
              self.setState({ loading: false });
            })
            .catch((err) => {
              this.errorMessage(err);
              self.setState({ loading: false });
            });
        } else {
          this.setState({ loading: false });
        }
      } else {
        message.error(`Email wajib diisi`);
        this.setState({ loading: false });
      }
    });
  };

  createSales = (e) => {
    let self = this;
    e.preventDefault();
    this.setState({ loading: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (values.nrp) {
        let dataField = [
          "name",
          "email",
          "phone",
          "nrp",
          "branchId",
          "supervisorId",
          "noNPWP",
          "noKTP",
          "bankName",
          "bankAccNo",
          "bankBeneficiary",
          "whatsapp",
        ];
        if (!err) {
          let formData = new FormData();
          for (let i = 0; i < dataField.length; i++) {
            if (values[dataField[i]]) {
              formData.append(dataField[i], values[dataField[i]]);
            }
          }
          formData.append("password", values.nrp);

          let { npwpImage, ktpImage } = this.state;
          if (npwpImage) formData.append("NPWP", npwpImage);
          if (ktpImage) formData.append("KTP", ktpImage);
          axios
            .post("/admin-panel/user/create-salesman", formData)
            .then((result) => {
              message.success(`Berhasil menambah Sales ${values.name}`);
              this.props.history.push(
                `/home/${this.props.location.query.role}-user`
              );
            })
            .catch((err) => {
              this.errorMessage(err);
              self.setState({ loading: false });
            });
        } else {
          this.setState({ loading: false });
        }
      } else {
        this.setState({ loading: false });
        message.error(`NRP wajib diisi`);
      }
    });
  };

  createBOH = (e) => {
    let self = this;
    e.preventDefault();
    this.setState({ loading: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (values.email) {
        let dataField = [
          "name",
          "email",
          "phone",
          "nrp",
          "areaBranchId",
          "noNPWP",
          "noKTP",
          "bankName",
          "bankAccNo",
          "bankBeneficiary",
          "whatsapp",
        ];
        if (!err) {
          let formData = new FormData();
          for (let i = 0; i < dataField.length; i++) {
            if (values[dataField[i]]) {
              formData.append(dataField[i], values[dataField[i]]);
            }
          }
          formData.append("password", process.env.REACT_APP_DEFAULT_PASSWORD);

          let { npwpImage, ktpImage } = this.state;
          if (npwpImage) formData.append("NPWP", npwpImage);
          if (ktpImage) formData.append("KTP", ktpImage);

          axios
            .post("/admin-panel/user/create-boh", formData)
            .then((result) => {
              message.success(`Berhasil menambah BOH ${values.name}`);
              this.props.history.push(
                `/home/${this.props.location.query.role}-user`
              );
            })
            .catch((err) => {
              this.errorMessage(err);
              self.setState({ loading: false });
            });
        } else {
          this.setState({ loading: false });
        }
      } else {
        this.setState({ loading: false });
        message.error(`Email wajib diisi`);
      }
    });
  };

  createABM = (e) => {
    let self = this;
    e.preventDefault();
    this.setState({ loading: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (values.email) {
        if (!err) {
          let userData = {
            ...values,
            password: process.env.REACT_APP_DEFAULT_PASSWORD,
          };
          axios
            .post(`/admin-panel/user/create-abm`, userData)
            .then((result) => {
              message.success(`Berhasil Create ABM ${values.name}`);
              this.props.history.push(
                `/home/${this.props.location.query.role}-user`
              );
            })
            .catch((err) => {
              this.errorMessage(err);
              self.setState({ loading: false });
            });
        } else {
          this.setState({ loading: false });
        }
      } else {
        this.setState({ loading: false });
        message.error(`Email wajib diisi`);
      }
    });
  };

  createUser = (e, role) => {
    let self = this;
    e.preventDefault();
    this.setState({ loading: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (values.email) {
        if (!err) {
          let dataUser;
          // Role Branch Head & Supervisor //
          if (["branch-head", "supervisor"].includes(role)) {
            // Field List //
            let dataField = [
              "name",
              "email",
              "phone",
              "nrp",
              "branchId",
              "noNPWP",
              "noKTP",
              "bankName",
              "bankAccNo",
              "bankBeneficiary",
              "whatsapp",
            ];

            // Form Data //
            dataUser = new FormData();

            // Set data to form //
            for (let i = 0; i < dataField.length; i++) {
              let value = values[dataField[i]];
              if (value) {
                // Jika Branch Id Array
                if (dataField[i] == "branchId" && Array.isArray(value)) {
                  dataUser.append("branchId", JSON.stringify(value));
                } else {
                  dataUser.append(dataField[i], value);
                }
              }
            }
            dataUser.append("password", process.env.REACT_APP_DEFAULT_PASSWORD);

            let { npwpImage, ktpImage } = this.state;
            if (npwpImage) dataUser.append("NPWP", npwpImage);
            if (ktpImage) dataUser.append("KTP", ktpImage);
            // End Set data to form //
          } else if (role === "mobbi-supervisor") {
            dataUser = {
              name: values.name,
              email: values.email,
              phone: values.phone,
              password: process.env.REACT_APP_DEFAULT_PASSWORD,
              branchIds: values.branchId,
            };
          } else {
            dataUser = {
              name: values.name,
              email: values.email,
              nrp: values.nrp,
              phone: values.phone,
              password: process.env.REACT_APP_DEFAULT_PASSWORD,
              branchId: values.branchId,
            };

            if (role == "tnt") {
              dataUser.branchId = JSON.stringify(values.branchId);
            }
          }
          axios
            .post(`/admin-panel/user/create-${role}`, dataUser)
            .then((result) => {
              message.success(
                `Berhasil menambah ${this.getQueryUser()} ${values.name}`
              );
              this.props.history.push(
                `/home/${this.props.location.query.role}-user`
              );
            })
            .catch((err) => {
              this.errorMessage(err);
              self.setState({ loading: false });
            });
        } else {
          this.setState({ loading: false });
        }
      } else {
        this.setState({ loading: false });
        message.error(`Email wajib diisi`);
      }
    });
  };

  componentDidMount() {
    this.fetchBranch();
    this.fetchSupervisor();
    this.fetchMobbiSupervisor();
    this.fetchAreaBranch();
    this.fetchAreaBusiness();
    this.fetchTNT();
  }

  async fetchBranch() {
    const {
      data: { branches },
    } = await axios.get(`/misc/branches`);
    this.setState({ branches });
  }

  async fetchAreaBranch() {
    const {
      data: { areaBranches },
    } = await axios.get(`/misc/area-branches`);
    this.setState({ areaBranches });
  }

  async fetchSupervisor() {
    const {
      data: { supervisors },
    } = await axios.get(`/misc/supervisors`);
    this.setState({ supervisors });
  }

  async fetchMobbiSupervisor() {
    const {
      data: { mobbiSupervisors },
    } = await axios.get(`/misc/mobbi-supervisors`);
    this.setState({ mobbiSupervisors });
  }

  async fetchTNT() {
    const {
      data: { tntUsers },
    } = await axios.get(`/misc/tnt-users`);
    this.setState({ tntUsers });
  }

  async fetchAreaBusiness() {
    const {
      data: { areas },
    } = await axios.get(`/misc/area-business`);
    this.setState({ areaBusinesses: areas });
  }

  callback(key, props) {
    props.form.resetFields();
  }

  errorMessage(e) {
    if (e.response) {
      if (e.response.data || e.response.message) {
        message.error(
          e.response.data.message || e.response.message || e.response.data
        );
      } else {
        message.error("Error Create User");
      }
    } else {
      message.error("Error Create User");
    }
  }

  formComponent(status) {
    const { getFieldDecorator } = this.props.form;
    let formNrp,
      formMultipleBranch,
      formBranch,
      formArea,
      formSupervisor,
      formNoWhatsapp,
      formBankName,
      formBankAcc,
      formBankBeneficiary,
      formNoKTP,
      formNoNPWP,
      formKTPImage,
      formNPWPImage,
      showKTPImage,
      showNPWPImage,
      formDisableAppraisal;

    // Form Name //
    let formName = (
      <FormItem label="Nama">
        {getFieldDecorator("name", {
          rules: [{ required: true, message: "Nama wajib diisi" }],
        })(<Input />)}
      </FormItem>
    );

    // Form Email //
    let formEmail = (
      <FormItem label="Email">
        {getFieldDecorator("email", {
          rules: [
            {
              required: true,
              type: "email",
              message: "Plase input valid email format",
            },
          ],
        })(<Input type="email" />)}
      </FormItem>
    );

    // Form NRP //
    if (["branch-head", "sales", "supervisor", "boh"].includes(status)) {
      // Form Upload //
      if (["branch-head", "sales", "supervisor"].includes(status)) {
        // Form NRP //
        formNrp = (
          <FormItem label="NRP">
            {getFieldDecorator("nrp", {
              rules: [
                {
                  required: true,
                  message: "NRP wajib diisi",
                },
              ],
            })(<Input />)}
          </FormItem>
        );
      }

      // Form Whatsapp //
      if (status === "sales") {
        formNoWhatsapp = (
          <FormItem label="No. Whatsapp">
            {getFieldDecorator("whatsapp", {})(<Input />)}
          </FormItem>
        );
      }

      // Form NPWP Image //
      formNPWPImage = (
        <FormItem label="Foto NPWP">
          {this.state.npwpImage && (
            <img
              alt="NPWP Image"
              width={"300px"}
              height={"250px"}
              style={{ objectFit: "cover", cursor: "pointer" }}
              src={URL.createObjectURL(this.state.npwpImage)}
              onClick={() => this.visibleModal("npwp", true)}
            />
          )}
          <div style={{ marginTop: 5 }}>
            {this.state.npwpImage && (
              <Button
                style={{ marginRight: 5 }}
                type="danger"
                onClick={() => this.setSelectedImage(null, "npwp")}>
                Remove
              </Button>
            )}

            <input
              ref={this.fileInputNPWP}
              type="file"
              name="file"
              style={{ display: "none" }}
              accept="image/*"
              onChange={(event) => {
                this.setSelectedImage(event.target.files[0], "npwp");
              }}
            />

            <Button
              type="primary"
              onClick={() => this.triggerInputFile("npwp")}>
              Upload NPWP
            </Button>
          </div>
        </FormItem>
      );

      // Form KTP Image //
      formKTPImage = (
        <FormItem label="KTP Image">
          {this.state.ktpImage && (
            <img
              alt="KTP Image"
              width={"300px"}
              height={"250px"}
              style={{ objectFit: "cover", cursor: "pointer" }}
              src={URL.createObjectURL(this.state.ktpImage)}
              onClick={() => this.visibleModal("ktp", true)}
            />
          )}
          <div style={{ marginTop: 5 }}>
            {this.state.ktpImage && (
              <Button
                style={{ marginRight: 5 }}
                type="danger"
                onClick={() => this.setSelectedImage(null, "ktp")}>
                Remove
              </Button>
            )}

            <input
              ref={this.fileInputKTP}
              type="file"
              name="file"
              style={{ display: "none" }}
              accept="image/*"
              onChange={(event) => {
                this.setSelectedImage(event.target.files[0], "ktp");
              }}
            />

            <Button type="primary" onClick={() => this.triggerInputFile("ktp")}>
              Upload KTP
            </Button>
          </div>
        </FormItem>
      );

      // Show KTP Image //
      showKTPImage = this.state.visibleModalKTP && (
        <Lightbox
          mainSrc={URL.createObjectURL(this.state.ktpImage)}
          onCloseRequest={() => this.visibleModal("ktp", false)}
        />
      );

      // Show NPWP Image //
      showNPWPImage = this.state.visibleModalNPWP && (
        <Lightbox
          mainSrc={URL.createObjectURL(this.state.npwpImage)}
          onCloseRequest={() => this.visibleModal("npwp", false)}
        />
      );

      // Form Bank Name //
      formBankName = (
        <FormItem label="Bank">
          {getFieldDecorator("bankName", {})(<Input />)}
        </FormItem>
      );

      // Form Bank Acc //
      formBankAcc = (
        <FormItem label="No. Rekening">
          {getFieldDecorator("bankAccNo", {})(<Input />)}
        </FormItem>
      );

      // Form Bank Beneficiary //
      formBankBeneficiary = (
        <FormItem label="Nama Pemilik Rekening">
          {getFieldDecorator("bankBeneficiary", {})(<Input />)}
        </FormItem>
      );

      // Form No KTP //
      formNoKTP = (
        <FormItem label="No. KTP">
          {getFieldDecorator("noKTP", {})(<Input />)}
        </FormItem>
      );

      // Form No NPWP //
      formNoNPWP = (
        <FormItem label="No. NPWP">
          {getFieldDecorator("noNPWP", {})(<Input />)}
        </FormItem>
      );
    }

    // Form No Handphone //
    let formPhone = (
      <FormItem label="Nomor Handphone">
        {getFieldDecorator("phone", {
          rules: [{ required: true, message: "Nomor Handphone wajib diisi" }],
        })(<Input />)}
      </FormItem>
    );

    // Form Disbale Approval //
    if (["appraiser"].includes(status)) {
      formDisableAppraisal = (
        <FormItem label="On / Off Appraiser" valuePropName="checked">
          {getFieldDecorator("isDisableAppraisal", {
            initialValue: false,
          })(<Switch />)}
        </FormItem>
      );
    }

    // Form Branch //
    if (["sales", "supervisor"].includes(status)) {
      formBranch = (
        <FormItem label="Cabang">
          {getFieldDecorator("branchId", {
            initialValue: this.state.branches[0]
              ? this.state.branches[0].id
              : "",
          })(
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              placeholder="Select a branch">
              {this.state.branches.map((branch, index) => (
                <Option key={index} value={branch.id}>
                  {branch.partnerName}
                </Option>
              ))}
            </Select>
          )}
        </FormItem>
      );
    }

    // Form Multiple Branch //
    if (["branch-head", "tnt", "mobbi-supervisor"].includes(status)) {
      formMultipleBranch = (
        <FormItem label="Cabang">
          {getFieldDecorator("branchId", {
            initialValue: [],
          })(
            <Select
              showSearch
              mode="multiple"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              placeholder="Select a branch">
              {this.state.branches.map((branch, index) => (
                <Option key={index} value={branch.id}>
                  {branch.partnerName}
                </Option>
              ))}
            </Select>
          )}
        </FormItem>
      );
    }

    // Form Area //
    if (["boh"].includes(status)) {
      formArea = (
        <FormItem label="Area">
          {getFieldDecorator(
            "areaBranchId",
            {}
          )(
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              placeholder="Select a person">
              {this.state.areaBranches.map((area, index) => (
                <Option key={index} value={area.id}>
                  {area.name}
                </Option>
              ))}
            </Select>
          )}
        </FormItem>
      );
    }

    // Form Area //
    if (["abm"].includes(status)) {
      formArea = (
        <FormItem label="Area">
          {getFieldDecorator("areaBusinessId")(
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              placeholder="Select a area">
              {this.state.areaBusinesses.map((area, index) => (
                <Option key={index} value={area.id}>
                  {area.area}
                </Option>
              ))}
            </Select>
          )}
        </FormItem>
      );
    }

    // Form Supervisor //
    if (["sales"].includes(status)) {
      formSupervisor = (
        <FormItem label="Supervisor">
          {getFieldDecorator("supervisorId", {
            initialValue: this.state.supervisors[0]
              ? this.state.supervisors[0].id
              : "",
          })(
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              placeholder="Select a person">
              {this.state.supervisors.map((spv, index) => (
                <Option key={index} value={spv.id}>
                  {spv.name}
                </Option>
              ))}
            </Select>
          )}
        </FormItem>
      );
    }

    // Form Button Create //
    let formButtonCreate = (
      <Row type="flex" justify="end">
        <Col>
          <Button htmlType="submit" type="primary">
            Create
          </Button>
        </Col>
      </Row>
    );

    switch (status) {
      case "sales":
        return (
          <Form onSubmit={this.createSales}>
            {formName}
            {formNrp}
            {formEmail}
            {formPhone}
            {formBranch}
            {formSupervisor}
            {formNoWhatsapp}
            {formBankName}
            {formBankAcc}
            {formBankBeneficiary}
            {formNoKTP}
            {formNoNPWP}
            {formNPWPImage}
            {formKTPImage}
            <RolePicker form={this.props.form} roles={status} />
            {formButtonCreate}
            {showKTPImage}
            {showNPWPImage}
          </Form>
        );

      case "pricing":
      case "dispatcher":
      case "ali":
      case "general-manager":
      case "finance":
        return (
          <Form onSubmit={(e) => this.handleSubmit(e, status)}>
            {formName}
            {formEmail}
            {formPhone}
            <RolePicker form={this.props.form} roles={status} />
            {formButtonCreate}
          </Form>
        );

      case "appraiser":
        return (
          <Form onSubmit={(e) => this.createAppraiser(e, status)}>
            {formName}
            {formEmail}
            {formPhone}
            {formDisableAppraisal}
            <RolePicker form={this.props.form} roles={status} />
            {formButtonCreate}
          </Form>
        );
      case "mobbi-supervisor":
        return (
          <Form onSubmit={(e) => this.createUser(e, status)}>
            {formName}
            {formEmail}
            {formPhone}
            {formMultipleBranch}
            <RolePicker form={this.props.form} roles={status} />
            {formButtonCreate}
          </Form>
        );

      case "tnt":
      case "branch-head":
        return (
          <Form onSubmit={(e) => this.createUser(e, status)}>
            {formName}
            {formEmail}
            {formNrp}
            {formPhone}
            {formMultipleBranch}
            {status == "branch-head" && (
              <div>
                {formBankName}
                {formBankAcc}
                {formBankBeneficiary}
                {formNoKTP}
                {formNoNPWP}
                {formNPWPImage}
                {formKTPImage}
                {showKTPImage}
                {showNPWPImage}
              </div>
            )}
            <RolePicker form={this.props.form} roles={status} />
            {formButtonCreate}
          </Form>
        );

      case "supervisor":
        return (
          <Form onSubmit={(e) => this.createUser(e, status)}>
            {formName}
            {formEmail}
            {formNrp}
            {formPhone}
            {formBranch}
            {formBankName}
            {formBankAcc}
            {formBankBeneficiary}
            {formNoKTP}
            {formNoNPWP}
            {formNPWPImage}
            {formKTPImage}
            <RolePicker form={this.props.form} roles={status} />
            {formButtonCreate}
            {showKTPImage}
            {showNPWPImage}
          </Form>
        );

      case "boh":
        return (
          <Form onSubmit={this.createBOH}>
            {formName}
            {formEmail}
            {formPhone}
            {formArea}
            {formBankName}
            {formBankAcc}
            {formBankBeneficiary}
            {formNoKTP}
            {formNoNPWP}
            {formNPWPImage}
            {formKTPImage}
            <RolePicker form={this.props.form} roles={status} />
            {formButtonCreate}
            {showKTPImage}
            {showNPWPImage}
          </Form>
        );

      case "abm":
        return (
          <Form onSubmit={this.createABM}>
            {formName}
            {formEmail}
            {formPhone}
            {formArea}
            <RolePicker form={this.props.form} roles={status} />
            {formButtonCreate}
          </Form>
        );
    }
  }

  getRoleUser(role) {
    let result;
    if (role === "all") result = "all";
    else if (role === "sales") result = "Salesman";
    else if (role === "appraiser") result = "Appraiser";
    else if (role === "branch-head") result = "Branch Head";
    else if (role === "supervisor") result = "Supervisor";
    else if (role === "ali") result = "Acquisition Logistic & Inventory";
    else if (role === "pricing") result = "Pricing";
    else if (role === "boh") result = "BOH";
    else if (role === "tnt") result = "TNT";
    else if (role === "other") result = "Other";
    else if (role === "mobbi-supervisor") result = "Mobbi Supervisor";
    else if (role === "dispatcher") result = "Dispatcher";
    else if (role === "general-manager") result = "General Manager";
    return result;
  }

  render() {
    return (
      <Card title="Create User">
        <Spin tip="Sedang menambahkan User Baru" spinning={this.state.loading}>
          <Tabs
            defaultActiveKey="1"
            onChange={(e) => this.callback(e, this.props)}>
            <TabPane tab={`Create ${this.getQueryUser()} User`} key="1">
              {this.formComponent(this.props.location.query.role)}
            </TabPane>
          </Tabs>
          {["all"].includes(this.props.location.query.role) && (
            <Tabs
              defaultActiveKey="0"
              onChange={(e) => this.callback(e, this.props)}>
              {[
                "sales",
                "appraiser",
                "branch-head",
                "supervisor",
                "tnt",
                "boh",
                "pricing",
                "dispatcher",
                "ali",
                "abm",
                "general-manager",
              ].map((role, index) => (
                <TabPane
                  tab={`Create ${this.getRoleUser(role)} User`}
                  key={index}>
                  {this.formComponent(role)}
                </TabPane>
              ))}
            </Tabs>
          )}
        </Spin>
      </Card>
    );
  }
}

export default Form.create()(UserCreate);



// WEBPACK FOOTER //
// src/components/Dashboard/User/UserCreate.js